// Unsplash CDN tuning: auto=format serves WebP/AVIF to supporting browsers,
// fit=max + w caps the download to roughly the rendered size.
// Non-Unsplash URLs (uploaded media, logo, etc.) pass through unchanged.
export const optImg = (url, w = 1200) => {
  if (!url || typeof url !== "string" || !url.includes("images.unsplash.com")) return url;
  const u = new URL(url);
  u.searchParams.set("auto", "format");
  u.searchParams.set("fit", "max");
  u.searchParams.set("w", String(w));
  u.searchParams.set("q", "75");
  return u.toString();
};
